import { useJobNotificationToggle } from '../../hooks/useJobNotificationToggle';
import { isMobileOS } from '../../utils/jobNotifications';
import './NotifyToggleSwitch.css';

/**
 * ジョブ完了ブラウザ通知の ON/OFF スイッチ（スライダ型）。
 * ステータスバー（colored 背景）と生成キューウィンドウ（light 背景）の 2 箇所で使うため
 * variant で配色を切り替える。状態は useJobNotificationToggle 経由で両者同期。
 *
 * モバイル OS（iOS/Android）ではバックグラウンド時に完了を検知できず通知が機能しない
 * （notifyJobComplete 側でも抑止）ため、トグルも表示しない。画面幅ではなく OS で判定する
 * ので、狭いデスクトップウィンドウでは表示されたまま（実際に機能する）。
 */
export function NotifyToggleSwitch({ variant }: { variant: 'statusbar' | 'panel' }) {
  const { supported, enabled, toggle } = useJobNotificationToggle();
  if (isMobileOS() || !supported) return null;

  return (
    <button
      type="button"
      role="switch"
      aria-checked={enabled}
      className={`notify-switch notify-switch--${variant} ${enabled ? 'is-on' : ''}`}
      title={enabled
        ? '完了時にブラウザ通知を出します（別タブ・最小化中も通知）'
        : '完了時にブラウザ通知を受け取る'}
      // 親（ステータスバー）のクリックでキューを開く挙動と競合させない
      onClick={(e) => { e.stopPropagation(); toggle(); }}
    >
      <span className="notify-switch__track">
        <span className="notify-switch__thumb" />
      </span>
      <span className="notify-switch__label">完了通知{enabled ? 'あり' : 'なし'}</span>
    </button>
  );
}
